const info = {
  CN: {
    title: "深圳建泰监测-实时监测平台",
    keywords: "传感器,采集器,实时监测,隧道,基坑,边坡,桥梁,大坝,高楼,岩土,应变,应力,变形,形变,水压,沉降,位移,振动,地震,结构,变形,数据采集,实时,结构健康,监测仪器,土壤调查,岩土仪器",
    description:"深圳市建泰监测技术有限公司,专注结构健康实时监测,传感器采集器研发生产,实时监测平台及解决方案供应商"
  },
  EN: {
    title: "Sensingtech RTM",
    keywords: "Sensor, collector, real-time monitoring, tunnel, foundation pit, slope, bridge, dam, high-rise building, geotechnical, strain, stress, deformation, deformation, water pressure, settlement, displacement, vibration, earthquake, structure, deformation, data acquisition, real-time, structural health, monitoring instrument, soil survey, geotechnical instrument.",
    description:"SENSINGTECH PTE.LTD focuses on real-time monitoring of structural health, research and production of sensor collectors, and suppliers of real-time monitoring platforms and solutions."
  }
};
export default info; //需要暴露出去


// WEBPACK FOOTER //
// ./src/language/user/meta.js